<template>
    <div>
        <v-card class="mb-6 pa-3 pa-md-6 visit-info-card">
            <validation-provider ref="visitorsProvider" rules="required" v-slot="{ errors }" mode="passive">
                <v-select style="display:none" v-model="innerInfo.visitors">
                </v-select>
                <v-alert
                    v-if="errors.length"
                    type="error"
                    text
                    class="pa-2"
                    icon="fa-exclamation-circle"
                >
                    {{ errors[0] }}
                </v-alert>
            </validation-provider>

            <v-card-title class="pa-0 mb-3">
                방문자 정보
                <v-btn
                    depressed
                    outlined
                    small
                    width="75"
                    color="var(--primary-color, #023894)"
                    class="ml-auto font-weight-bold"
                    @click="showVisitorDialog"
                >
                    등록
                    <v-icon right>mdi-account-plus</v-icon>
                </v-btn>
            </v-card-title>

            <v-data-table
                :headers="headers"
                :items="innerInfo.visitors"
                :value="selectedVisitors"
                :items-per-page="-1"
                item-key="id"
                no-data-text="등록된 방문자가 없습니다"
                mobile-breakpoint="900"
                hide-default-footer
                selectable-key="selectable"
                disable-sort
                @input="selectVisitor"
            >

                <template v-slot:item.visitorName="{ item }">
                    <v-chip v-if="item.vip === 'Y'"
                            x-small
                            color="red"
                            text-color="white"
                            class="mr-1"
                    >VIP
                    </v-chip>
                    {{ item.visitorName }}
                </template>

                <template v-slot:item.actions="{ item }">
                    <template>
                        <v-icon
                            small
                            class="mr-2"
                            @click="editVisitor(item)"
                        >
                            mdi-pencil
                        </v-icon>
                        <v-icon
                            small
                            @click="deleteVisitor(item)"
                        >
                            mdi-delete
                        </v-icon>
                    </template>
                </template>
            </v-data-table>
        </v-card>

        <regist-visitor-dialog
            v-model="dialog.show"
            :target-visitor="dialog.visitor"
            :agent="agent"
            @save="saveVisitor"
            @close="closeVisitorDialog"
        ></regist-visitor-dialog>
    </div>
</template>

<script>
import {mapState} from "vuex";
import RegistVisitorDialog from "@/components/RegistVisitorDialog.vue";
import {extend, ValidationProvider} from "vee-validate";
import {required} from "vee-validate/dist/rules";

export default {
    name: 'ApplyStep3',

    props: {
        value: {
            type: Array,
            default: () => []
        },
        carryInItems: {
            type: Array,
            default: () => []
        },
        agent: {
            type: Object
        },
    },

    components: {
        RegistVisitorDialog,
        ValidationProvider
    },

    data: () => ({
        isInit: false,
        isLoading: false,
        selectedVisitors: [],
        headers: [
            {text: '방문자', value: 'visitorName'},
            {text: '휴대폰', value: 'visitorMobile'},
            {text: '업체', value: 'visitorCompany'},
            {text: '차량번호', value: 'visitorCarNumber'},
            {text: '액션', value: 'actions', sortable: false},
        ],

        dialog: {
            show: false,
            visitor: null,
        },

        innerInfo: {
            visitors: [],
        },

        required: true,
    }),

    computed: {
        ...mapState(['currentUser', 'secretKey', 'iv']),
    },

    watch: {
        'innerInfo.visitors': {
            handler(v) {
                this.$emit('input', v);
            },
            deep: true
        },
    },

    created() {
        this.init();
    },

    methods: {
        init() {
            this.innerInfo.visitors = this.value;
            this._initConfig();
            this._initRules();
            this.isInit = true;
        },

        _initConfig() {
            if (this.$code.get('service.config.use_visit_period') !== 'Y') {
                const idx = this.headers.findIndex(h => h.value === 'endDatetime')
                if (idx !== -1) {
                    this.headers.splice(idx, 1);
                }
            }

            if (this.$code.get('service.config.use_birthday') !== 'Y') {
                const idx = this.headers.findIndex(h => h.value === 'visitorBirthday')
                if (idx !== -1) {
                    this.headers.splice(idx, 1);
                }
            }
        },

        _initRules() {
            // const self = this;
            extend('required', {
                ...required,
                message: '방문자를 등록하세요.'
            })
        },

        closeVisitorDialog() {
            this.dialog.visitor = null;
            this.dialog.show = false;
        },

        showVisitorDialog() {
            this.dialog.show = true;
        },

        saveVisitor(visitor) {
            const foundVisitor = this.innerInfo.visitors.find(v => v.visitorId === visitor.visitorId);

            if (foundVisitor) {
                Object.assign(foundVisitor, visitor);
            } else {
                this.innerInfo.visitors.push(visitor);
            }
            this.dialog.visitor = null;
        },

        editVisitor(visitor) {
            this.dialog.visitor = visitor;
            this.dialog.show = true;
        },

        _deleteVisitor(visitor) {
            const idx = this.innerInfo.visitors.findIndex(v => v.visitorId === visitor.visitorId);
            this.innerInfo.visitors.splice(idx, 1);
        },

        async deleteVisitor(visitor) {
            const carryInItems = this.carryInItems.filter(e => e.visitorId === visitor.visitorId);

            if (carryInItems.length > 0) {
                const result = await this.$window.confirm("반입물품이 존재합니다. 삭제하시겠습니까?");

                if (result) {
                    carryInItems.forEach(e => {
                        this.deleteCarryIn(e);
                    });

                    this._deleteVisitor(visitor);
                }
            } else {
                this._deleteVisitor(visitor);
            }
        },

        selectVisitor(selectVisitors) {
            this.selectedVisitors = selectVisitors;
        },

        async deleteVisitors() {
            this.selectedVisitors.forEach(v => {
                this.deleteVisitor(v);
            });
        },

        deleteCarryIn(carryInItem) {
            const idx = this.carryInItems.findIndex(v => v.importId === carryInItem.importId);
            const list = this.carryInItems.splice(idx, 1);
            this.$emit('update:carryInItems', list);
        },
    }

}
</script>

<style scoped>
>>> .v-data-table__empty-wrapper td {
    font-size: 1rem !important;
}
</style>